<template>
    <v-dialog v-model="shows" max-width="1080" persistent :fullscreen="$vuetify.breakpoint.smAndDown" content-class="rounded-sm-0">
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }" height="100%" rounded="0">
            <v-card-title>
                <template>예약 상세</template>
                <v-spacer />
                <v-btn absolute right text icon @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider />
            <v-sheet class="pa-0 pb-1 mb-n1" style="max-height: calc(90vh - 16px - 32px - 10px - 1px - 1px - 60px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col cols="12" lg="5">
                        <form-table-row label="회원">
                            <autocomplete-user v-model="$data._user" hide-details dense v-bind="{ loading, disabled, outlined: false, readonly: !!schedules.length, readonlyMessage: '동시에 회원 한 명의 스케줄만 등록할 수 있습니다.\n\n다른 회원의 예약을 생성하기 위해서는 선택한 스케줄을 모두 제거하셔야 합니다.' }" ref="autocomplete-user" />
                        </form-table-row>
                        <form-table-row label="설비">
                            <autocomplete-rental-subject v-model="$data._subject" hide-details dense v-bind="{ loading, disabled, outlined: false }" ref="autocomplete-rental-subject" />
                        </form-table-row>
                        <form-table-row label="사용목적">
                            <v-text-field v-model="usage" hide-details dense v-bind="{ loading, disabled }" />
                        </form-table-row>
                        <template v-if="$vuetify.breakpoint.xsOnly">
                            <div class="pa-3 grey lighten-5 subtitle-2 font-weight-bold">예약일</div>
                            <v-divider />
                            <v-layout justify-center>
                                <rental-schedule-date-picker v-model="date" v-bind="{ loading, disabled }" />
                            </v-layout>
                            <v-divider />
                        </template>
                        <template v-else>
                            <form-table-row label="예약일" contentClass="d-flex justify-center">
                                <rental-schedule-date-picker v-model="date" v-bind="{ loading, disabled }" />
                            </form-table-row>
                        </template>
                        <form-table-row label="예약시간">
                            <rental-schedule-time-picker v-model="schedules" v-bind="{ loading, subject, limitationMet, schedulesOnCloud, date, _user: $data._user }" v-on="{ del }" />
                        </form-table-row>
                    </v-col>
                    <v-col cols="12" lg="auto">
                        <v-divider class="d-none d-lg-block" vertical />
                        <v-divider class="d-block d-lg-none" />
                    </v-col>
                    <v-col cols="12" lg="">
                        <div class="pa-3 grey lighten-5 subtitle-2 font-weight-bold">선택한 스케줄</div>
                        <v-divider />
                        <rental-schedule-selected v-model="schedules" v-bind="{ loading, users, subjects }" v-on="{ del }" />
                    </v-col>
                </v-row>
            </v-sheet>
            <v-divider />
            <v-card-actions class="px-6 grey lighten-5">
                <v-btn large outlined v-bind="{ loading }" @click="init">초기화</v-btn>
                <template v-if="disabled"> 예약을 계속하시려면 선택한 스케줄을 먼저 초기화 해주세요 </template>
                <v-spacer />
                <v-btn large color="primary" v-bind="{ loading, disabled }" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
            <slot name="loader" />
        </v-card>
        <rental-schedule-limitation-per-week v-model="limitationPerWeekMet" v-bind="{ _user: $data._user, date, limitations, schedules }" />
    </v-dialog>
</template>

<script>
import api from "@/api";
import { RENTAL_SCHEDULE_STATES } from "@/assets/variables";

import FormTableRow from "../dumb/form-table-row.vue";
import AutocompleteUser from "@/components/dumb/autocomplete-user.vue";
import RentalScheduleSelected from "./rental-schedule-selected.vue";
import RentalScheduleDatePicker from "@/components/dumb/rental-schedule-date-picker.vue";
import RentalScheduleTimePicker from "@/components/dumb/rental-schedule-time-picker.vue";
import AutocompleteRentalSubject from "@/components/dumb/autocomplete-rental-subject.vue";
import RentalScheduleLimitationPerWeek from "./rental-schedule-limitation-per-week.vue";
import dayjs from 'dayjs';

export default {
    components: {
        FormTableRow,
        AutocompleteUser,
        RentalScheduleSelected,
        RentalScheduleDatePicker,
        RentalScheduleTimePicker,
        AutocompleteRentalSubject,
        RentalScheduleLimitationPerWeek,
    },
    data: () => ({
        shows: false,
        loading: false,

        _user: null,
        _subject: null,
        date: Date.now().toDate(),
        usage: null,

        users: [],
        subjects: [],

        limitations: [],
        limitationPerWeekMet: false,

        schedulesOnCloud: [],

        schedules: [],
    }),
    computed: {
        subject() {
            return this.subjects.find(({ _id }) => _id == this.$data._subject);
        },
        disabled() {
            return this.schedules.some(({ _id }) => _id);
        },
        limitationMet() {
            return this.limitationPerWeekMet;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            if (this.shows) {
                if (this.subject?._id && this.$data._user) this.getSchedules();
            } else this.init();
        },
        "$data._user"() {
            if (this.$data._user) {
                let user = this.$refs["autocomplete-user"]?.$data.users.find(({ _id }) => _id == this.$data._user);
                let index = this.users.findIndex(({ _id }) => _id == user._id);
                if (index > -1) {
                    this.users.splice(index, 1, user);
                } else {
                    this.users.push(user);
                }
            }
            if (this.shows && this.subject?._id && this.$data._user) this.getSchedules();
        },
        subject() {
            if (this.shows && this.subject?._id && this.$data._user) this.getSchedules();
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                this.schedules = [];
                this.$data._user = null;
                this.$data._subject = null;
                this.date = Date.now().toDate();
                this.usage = null;
                this.users = [];
                this.subjects = [];
                this.limitations = [];
                this.limitationPerWeekMet = false;
                this.schedulesOnCloud = [];
                this.schedules = [];

                let { subjects } = await api.v1.rental.subjects.gets({ params: { shows: true } });
                this.subjects = subjects;

                let { limitations } = await api.v1.rental.limitations.gets({ params: { uses: true } });
                this.limitations = limitations;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async getSchedules() {
            this.loading = true;
            try {
                let { _subject, date } = this.$data;
                let { APPLIED, APPROVED } = RENTAL_SCHEDULE_STATES;
                let { schedules } = await api.console.rental.schedules.gets({
                    params: { _subject, date, state: [APPLIED.value, APPROVED.value] },
                });
                this.schedulesOnCloud = schedules;
            } finally {
                this.loading = false;
            }
        },

        async save() {
            this.loading = true;
            let { usage } = this;
            this.schedules = [
                ...(await Promise.all(
                    this.schedules.map(async (item) => {
                        try {
                            return { ...(await api.console.rental.schedules.post({ ...item, usage }))?.schedule, success: true };
                        } catch (error) {
                            console.error(error);
                            return { ...item, success: false };
                        }
                    })
                )),
            ];
            let failedItemsLength = this.schedules.filter(({ success }) => !success)?.length;
            if (failedItemsLength) {
                alert(`총 ${this.schedules.length} 건 중 ${failedItemsLength} 건의 예약 생성에 실패하였습니다.`);
            } else {
                alert("모든 예약 생성에 성공하였습니다.");
            }

            (() => {
                let { _user, _subject } = this.$data;
                let { type } = this.subject || {};

                console.log("isCalled?");

                let requests = this.schedules
                    .reduce((requests, { _id, date }) => {
                        if (_id) {
                            let group = requests.find((group) => group.date == date);
                            if (!group) {
                                requests.push({ _user, _subject, _schedules: [], date, type, usage });
                                group = requests[requests.length - 1];
                            }
                            group._schedules.push(_id);
                        }

                        return requests;
                    }, [])
                    .sort((a, b) => dayjs(a.date).isAfter(b.date));
                console.log({ requests });

                this.$emit("save", requests);
            })();
            this.loading = false;
        },

        del(schedule) {
            let { _subject, date, time } = schedule;
            let index = this.schedules.findIndex((item) => item._subject == _subject && item.date == date && item.time == time);
            if (index > -1) this.schedules.splice(index, 1);
        },
    },
};
</script>
